import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-51d0882c")

_pushScopeId("data-v-51d0882c")
const _hoisted_1 = { class: "fill df-col p-r" }
const _hoisted_2 = { class: "mt-10 d-f px-20 py-12" }
const _hoisted_3 = {
  key: 1,
  class: "flex-1"
}
const _hoisted_4 = {
  key: 3,
  class: "x2-tip br-lg d-f p-8 pb-0"
}
const _hoisted_5 = { class: "px-8 flex-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheSymbolMarketState = _resolveComponent("TheSymbolMarketState")
  const _component_TheChart = _resolveComponent("TheChart")
  const _component_TheMarketClosedTip = _resolveComponent("TheMarketClosedTip")
  const _component_TheSymbolActions = _resolveComponent("TheSymbolActions")
  const _component_Icon = _resolveComponent("Icon")
  const _component_t = _resolveComponent("t")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.symbol)
        ? (_openBlock(), _createBlock(_component_TheSymbolMarketState, {
            key: 0,
            symbol: _ctx.symbol
          }, null, 8, ["symbol"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.symbol)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.fullscreen)
            ? (_openBlock(), _createBlock(_component_TheChart, {
                key: 0,
                code: _ctx.symbol.code,
                class: "fullscreen",
                onFullscreen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fullscreen = false))
              }, null, 8, ["code"]))
            : (_openBlock(), _createBlock(_component_TheChart, {
                key: 1,
                code: _ctx.symbol.code,
                class: "chart flex-1",
                onFullscreen: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fullscreen = true))
              }, null, 8, ["code"]))
        ], 64))
      : (_openBlock(), _createBlock("div", _hoisted_3)),
    (_ctx.isClosed)
      ? (_openBlock(), _createBlock(_component_TheMarketClosedTip, {
          key: 2,
          symbol: _ctx.symbol
        }, null, 8, ["symbol"]))
      : _createCommentVNode("", true),
    _createVNode(_component_TheSymbolActions, {
      symbol: _ctx.symbol,
      code: _ctx.code
    }, null, 8, ["symbol", "code"]),
    (_ctx.showSpecialTip)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_Icon, {
            name: "help",
            sm: "",
            style: {"color":"var(--color-asst)"}
          }),
          _createVNode("div", _hoisted_5, [
            (_ctx.sepcialType === _ctx.ESpecialType.DOUBLE)
              ? (_openBlock(), _createBlock(_component_t, {
                  key: 0,
                  path: "symbol_104",
                  as: "div",
                  multiline: "",
                  custom: "",
                  args: { code: _ctx.code }
                }, {
                  default: _withId(({td}) => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(td, (p, index) => {
                      return (_openBlock(), _createBlock("p", {
                        class: "c-white mb-8",
                        key: index
                      }, _toDisplayString(p), 1))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["args"]))
              : _createCommentVNode("", true),
            (_ctx.sepcialType === _ctx.ESpecialType.REVERSE)
              ? (_openBlock(), _createBlock(_component_t, {
                  key: 1,
                  path: "symbol_105",
                  as: "div",
                  multiline: "",
                  custom: "",
                  args: { code: _ctx.code, origincode: _ctx.code.replace('INV', '') }
                }, {
                  default: _withId(({td}) => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(td, (p, index) => {
                      return (_openBlock(), _createBlock("p", {
                        class: "c-white mb-8",
                        key: index
                      }, _toDisplayString(p), 1))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["args"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_Icon, {
            name: "close",
            style: {"background-color":"var(--color-white)","border-radius":"50%","height":"24px","width":"24px","cursor":"pointer"},
            onClick: _ctx.handleCloseTip
          }, null, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
})